/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Report_Snapshotform_Validation_Periodrequired3Inputs */

const en_coinvestments_report_snapshotform_validation_periodrequired3 = /** @type {(inputs: Coinvestments_Report_Snapshotform_Validation_Periodrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Period is required`)
};

/**
* | output |
* | --- |
* | "Period is required" |
*
* @param {Coinvestments_Report_Snapshotform_Validation_Periodrequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_report_snapshotform_validation_periodrequired3 = /** @type {((inputs?: Coinvestments_Report_Snapshotform_Validation_Periodrequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Report_Snapshotform_Validation_Periodrequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_report_snapshotform_validation_periodrequired3(inputs)
});
export { coinvestments_report_snapshotform_validation_periodrequired3 as "coInvestments_report_snapshotForm_validation_periodRequired" }